export function ConservatoryTypeReducer(state = {}, action) {
    switch (action.type) {
        case "GET_CONSERVATORY_TYPES":
            return action.payload.result;
        case "ADD_CONSERVATORY_TO_LIST":
            return {};
        default:
            return state;
    }
}

export function ConservatorySizesReducer(state = [], action) {
    switch (action.type) {
        case "GET_CONSERVATORY_SIZES":
            return action.payload.result;
        case "ADD_CONSERVATORY_TO_LIST":
            return [];
        default:
            return state;
    }
}

export function ConservatoryStyleReducer(state = [], action) {
    switch (action.type) {
        case "GET_CONSERVATORY_STYLES":
            return action.payload.result;
        case "ADD_CONSERVATORY_TO_LIST":
            return [];
        default:
            return state;
    }
}

export function ConservatoryExtrasReducer(state = [], action) {
    switch (action.type) {
        case "GET_CONSERVATORY_EXTRAS":
            return action.payload.result;
        case "ADD_CONSERVATORY_TO_LIST":
            return [];
        default:
            return state;
    }
}

export function ConservatoryColourReducer(state = [], action) {
    switch (action.type) {
        case "GET_CONSERVATORY_TYPES":
            return action.payload.result;
        case "ADD_CONSERVATORY_TO_LIST":
            return [];
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/conservatory_reducers.js